import type { Href } from 'expo-router'
import { ImpersonationUrlHandler } from '../src/zportiAdmin/components/ImpersonationUrlHandler/ImpersonationUrlHandler'

/**
 * Marketing-site entry for the same headless flow as `/app/impersonate`.
 * Success and failures both return to `/` so operators stay on the marketing site.
 */
export default function SiteImpersonateRoute() {
  return (
    <ImpersonationUrlHandler exitReplaceHref={'/' as Href} successReplaceHref={'/' as Href} />
  )
}
